import { getCurrentLocale } from '@legacy/js/service/LanguageHelper.js';

const FALLBACK_LOCALE = 'de-DE';

/**
 * The backend hands out locales as `de_DE`, which `Intl` rejects with a RangeError.
 */
export function toIntlLocale(locale?: string | null): string {
    const candidate = (locale ?? '').replace(/_/g, '-');

    if (candidate === '') {
        return FALLBACK_LOCALE;
    }

    try {
        new Intl.NumberFormat(candidate);
        return candidate;
    } catch {
        return FALLBACK_LOCALE;
    }
}

/**
 * The locale the current page was rendered in, in a form `Intl` accepts.
 */
export function currentIntlLocale(): string {
    return toIntlLocale(getCurrentLocale());
}

export default toIntlLocale;
